// How much of a tour/package teaser an editor wants shown, as a named level
// rather than one boolean per region: three levels are three things to support,
// seven booleans are 128. A level also records intent ("this is a compact
// list"), so a later design change redefines it here instead of stranding
// today's region names in published Storyblok content.
//
// Media, eyebrow and title are absent on purpose — a teaser without them is not
// a teaser, so they are never a level's decision.
export const CARD_DETAIL_LEVELS = {
    full: { text: true, inclusions: true, price: true, action: true },
    compact: { text: true, inclusions: false, price: true, action: true },
    minimal: { text: false, inclusions: false, price: true, action: false },
}

// The level is a CEILING, never a force: callers keep their existing data gates
// and add `regions.x &&` on top. A level can only ever remove a region, so an
// editor cannot produce an empty price block by asking for `full` on a tour
// that has no price. Unknown or absent values fall back to `full`, which is
// today's output — same allow-list shape as article-cta.vue's CARD_VARIANTS.
export default function resolveDetailLevel(value) {
    return CARD_DETAIL_LEVELS[value] ?? CARD_DETAIL_LEVELS.full
}
